import { Transport, TransportMapTerm, TransportSide } from '@/new-transport/_models/transport.model';

export const getTermsFromTransport = (transport: Transport): TransportMapTerm[] => {
	const property = transport.side === TransportSide.DEPARTURE ? 'departureTerms' : 'returnTerms';

	return transport[property].map((term) => ({
		...term,
		transportStop: {
			...term.transportStop,
			location: term.transportStop.location.id,
		},
	}));
};
